import { GraphQLError } from 'graphql';

export const getGraphQLErrors = (e: Error & { graphQLErrors?: GraphQLError[] }): GraphQLError[] | undefined => {
  return e.graphQLErrors;
};

export function getErrorCodes(e: Readonly<GraphQLError[]>): string[] {
  return e.map((e) => e.extensions?.code).filter((c) => c !== undefined);
}
